import React, {useState} from 'react';
import { Container, Row, Col, Image, Form, Button, Modal } from 'react-bootstrap';
import CharacterCarousel from './CharacterCarousel';
import { Spinner } from 'react-bootstrap';
import firebase,{auth} from '../../firebase'
// import {auth} from '../../firebase'
// let auth = firebaseApp.auth()


  
  

const SignIn = () => {
    const [isLoading, setLoading ] = useState(false)
    const [message, setMessage] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")


    const backgroundImageStyle = {
    backgroundImage: `url('/images/base.png')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: 1.0,
    fontFamily:"Poppins"
  };


  const titleStyle = {
    fontSize: '1.5rem',
    marginBottom: '1rem',
  };

  const subheadingStyle = {
    fontSize: '0.9rem',
    marginBottom: '2rem',
  };

  const formContainerStyle = {
    backgroundColor: 'white',
    padding: '1rem',
    borderRadius: '8px',
  };

  const formStyle = {
    fontSize: '1rem',
  };
  const handleChange = (e)=>{
    setUsername(e.target.value)
    
  }
  const handleEmailChange = (e)=>{
    setEmail(e.target.value)
    
  }
  const handlePasswordChange = (e)=>{
    setPassword(e.target.value)
  }
  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  
    return emailRegex.test(email);
  }
  const signIn = (email, password) => {
    auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(() => {
 
    auth.signInWithEmailAndPassword(email, password).then((u)=>{
      
      setLoading(false)
      window.location.reload()
    }).catch((error)=>{
      setMessage(error.message)
      setLoading(false)
    });
   // You can call signInWithEmailAndPassword() or onAuthStateChanged() here
  })
  .catch((error) => {
    console.error('Error enabling local persistence:', error);
  });

  };
  const handleSignIn = (e) => {
    e.preventDefault();
    
    // if already loading dont send request again
    if (!isLoading){

        if (!isValidEmail(email)){
            setMessage("email invalid")
            return
        }
        if (password.length < 8){
            setMessage("password must have 8 or more characters")
            return
        }
        setMessage("")
        setLoading(true)
        signIn(email, password)
    }else{

    }


    // Open a modal or a new window to display your Terms of Service (TOS).
    // You can use a Modal component from React Bootstrap or open a new window.
  }
  return (
    <div style={backgroundImageStyle}>
      <Container>
        <Row className="justify-content-center vh-100 align-items-center">
          <Col lg={6} style={formContainerStyle}>
     
  
            <Form style={formStyle}  onSubmit={handleSignIn}>
              <h3 className="text-center mb-3">Sign In to your account</h3>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" onChange={handleEmailChange} value={email} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Enter your password" onChange={handlePasswordChange} value={password} />
              </Form.Group>
              
              <Button variant="primary" onClick={handleSignIn} disabled={isLoading}>
                Sign In
              </Button>
              {isLoading?<Spinner/>:""}
              
              
            </Form>
            <p style={{color:"red"}}>{message}</p>
          </Col>
          <CharacterCarousel />
        </Row>
        
      </Container>

      <footer>
        <a
          href="#"
          onClick={(e)=>{e.preventDefault()}}
        >
          Terms of Service
        </a>
      </footer>
    </div>
  );
};

export default SignIn;
